export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-PostgreSQL.a1cd5b91.png";